import styled from 'styled-components';
import MaterialFormHelperText from '@material-ui/core/FormHelperText';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const FormHelperText = styled(MaterialFormHelperText)``;

